import { Layout } from 'antd';
import React from 'react';

import classes from './Content.module.less';

const { Content: AntdContent } = Layout;

type Props = {
	children: JSX.Element;
};

const Content = ({ children }: Props) => {
	return <AntdContent className={classes.container}>{children}</AntdContent>;
};

export default Content;
